import styled from 'styled-components'

import { ReactComponent as Delete } from './icons/delete.svg'
import { ReactComponent as DeleteInput } from './icons/delete-input.svg'
import { ReactComponent as Edit } from './icons/edit.svg'


export const StyledFormBlock = styled.div`
	justify-content: space-between;
	flex-wrap: wrap;;
	width: '100%;
	display: 'flex;
`

export const StyledButtonBlock = styled.div`
	display: flex;
	text-align: center;
`

export const StyledProjectInfo = styled.div`
	display: flex;
	justify-content: space-between;
	width: 50%;
`
//
export const StyledProjectControls = styled.div`
	position: absolute;
	right: 0;
	z-index: 2;
	> div {
	  	margin-right: 0 !important;
	}
`

export const StyledFloorsBlock = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100%;
	width: 100%;
`

export const StyledFloorBlockLabel = styled.div`
	position: relative;
 	width: 100%;

`

export const StyledFloorEdit = styled(Edit)`
	cursor: pointer;
	margin-left: 10px

`

export const StyledFloorRemove = styled(Delete)`
	 position: absolute;
	 top: 15%;
	 right: 10px;
	 cursor: pointer;
`

export const StyledInputRemove = styled(DeleteInput)`
	 position: absolute;
	 top: 57%;
	 right: 20px;
	 cursor: pointer;
`


export const StyledFormInput = styled.div`
	position: relative;
	width: max-content;
`

export const StyledFloorInput = styled.div`
		width: 140px;
		margin-right: 6%;
		margin-bottom: 10%;
`

